export class AzureSqlDatabaseNativePitrConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "retentionDays",
            "baseName": "retentionDays",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureSqlDatabaseNativePitrConfig.attributeTypeMap;
    }
    constructor() {
    }
}
